<template>
  <div class="min-vh-100">
    <c-btn
      class="my-6"
      @click="back">
      {{ $t('actions.back') }}
    </c-btn>
    <v-row v-if="loading" align="center" justify="center" class="my-5">
      <v-progress-circular v-if="loading"
                           indeterminate
                           class="p-4"
                           color="primary">
      </v-progress-circular>
    </v-row>

    <div v-if="!loading" v-html="renderedContent"/>
    <c-btn
      class="my-6"
      @click="back">
      {{ $t('actions.back') }}
    </c-btn>
  </div>
</template>

<script>

export default {
  name: 'LegalTerms',
  data() {
    return {
      renderedContent: '',
      loading: ''
    }
  },
  methods: {
    back() {
      this.$router.back() || this.$router.push({name: 'home'})
    }
  },
  async mounted() {
    const name = this.$route.name
    this.loading = true
    const response = await fetch(`/legal/${name}.en.html`)
    this.renderedContent = await response.text()
    this.loading = false
  }
}
</script>
